import { Box } from '@mui/material'
import { ProgressReportsOverview } from './ProgressReportsOverview'
import { Route, Routes } from 'react-router-dom'
import { OrgProgressReports } from './ProgressReports'
import { MidYear } from './MidYear/MidYear'

export const ProgressReportsTab = (): JSX.Element => {
  return (
    <Box>
      <Routes>
        <Route path="/" element={<ProgressReportsOverview />} />
        <Route path="/Organization/:planOrgId" element={<OrgProgressReports />} />
        <Route path="/Organization/:planOrgId/MidYear" element={<MidYear/>} />
      </Routes>

    </Box>
  )
}
